import React from 'react';
// Data
import {
  dominatrixFormAdditionalMeta,
  dominatrixFormStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import DominatrixFormMainContainer from '../../components/booking/DominatrixFormMainContainer';
import AltHeader from '../../components/general/AltHeader';
import HeaderBanner from '../../components/general/HeaderBanner';
import FooterComponent from '../../components/footer/FooterComponent';

function DominatrixForm() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Application to Serve'
        desc='Apply to serve Mistress Maria by completing the Dominatrix application form. Provide your interests, limits, and other essential details to be considered for a BDSM session.'
        keywords='Mistress Maria, dominatrix application, serve Mistress, BDSM form, submissive application, kink form, apply to serve, sub application, fetish interests, limits, BDSM UK'
        additionalMeta={dominatrixFormAdditionalMeta}
        structuredData={dominatrixFormStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={'Domination Application Form'} />
          </header>
        </div>

        {/* Main page content */}
        <DominatrixFormMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default DominatrixForm;
